import React, {useContext, useEffect, useState} from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {auth, db} from "../utils/firebaseApp";
import Html5QrcodePlugin from "./qr-code-scanner/QrCustomComponent";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {AppContext} from "../utils/AppContext";
import {sumEverythingInCart} from "../utils/sharedFunctions";
import Box from "@mui/material/Box";
import {doc, getDoc, setDoc, updateDoc} from "firebase/firestore";
import './chargepage.css'
import chargeBackground from '../assets/charge.svg'
import {Contactless, Receipt} from "@mui/icons-material";
import {QrReaderC} from "./qr-code-scanner/QrCodeReaderComponentHtml5Only";
import {Header} from "../shared-components/Header";
import Button from "@mui/material/Button";
import {IconChevronCompactLeft} from "@tabler/icons-react";
import {IconButton} from "@mui/material";

const AddCash = () => {
    console.log('wallets page')
    const {state: {cart, currentUser}, dispatch} = useContext(AppContext);
    const [qrCodeResult, setQrCodeResult] = useState(null);
    const [isScanning, setIsScanning] = useState(true);
    const navigate = useNavigate()
    let desiredScannerState = null
    const totalToCharge = sumEverythingInCart(cart)

    // console.log(navigator.mediaDevices.enumerateDevices())
    async function getMediaDevices() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        console.log(devices)
    }

    getMediaDevices()

    useEffect(() => {
        if (qrCodeResult) chargeUser()
    }, [qrCodeResult])

    const chargeUser = () => {
        const txnTime = Date.now()
        const paymentCardRef = doc(db, "paymentCards", qrCodeResult);

        getDoc(paymentCardRef)
            .then((docSnap) => {
                if (docSnap.exists()) {
                    // Check if the bartender belongs to the same event they're trying to charge
                    const paymentCard = docSnap.data()
                    if (paymentCard.eventUid !== currentUser.event) {
                        toast.error('Nemate pristup ovom događaju!');
                        return;
                    }
                    const newAmount = parseInt(paymentCard.balance) - parseInt(totalToCharge)
                    console.log('newAmount')
                    console.log(newAmount)
                    if (newAmount < 0) {
                        toast.error('Nedovoljno tokena na racunu!!!', {autoClose: 5000})
                        setQrCodeResult(null)
                        dispatch({cart: []})
                        navigate('/stand')
                        return
                    }

                    updateDoc(doc(db, "paymentCards", qrCodeResult), {
                        lastChangeByUid: auth.currentUser.uid,
                        lastTransactionTime: txnTime,
                        balance: parseInt(paymentCard.balance) - parseInt(totalToCharge),
                    }).then(r => {
                        toast.success(`Charged 🪙${totalToCharge} to user: ${qrCodeResult}`)
                    }).catch(e => {
                        console.log(e)
                        toast.error('Adding failed, please try again')
                    })

                    setDoc(doc(db, "bartenderTransactions", crypto.randomUUID()), {
                        addedBy: auth.currentUser.uid,
                        addedByEmail: auth.currentUser.email,
                        timestamp: txnTime,
                        amountDeducted: parseInt(totalToCharge),
                        itemsSold: cart,
                        addedTo: qrCodeResult,
                        stand: currentUser.stand,
                        event: currentUser.event

                    }).then(r => {
                        setQrCodeResult(null)
                        dispatch({cart: []})
                        navigate('/stand')
                        // toast.success(`TXN ADDED: ${total} to user ${qrCodeResult}`)
                    }).catch(e => {
                        console.log(e)
                        toast.error('Adding failed, please try again')
                    })
                } else {
                    toast.error('No such user found please try again')
                }
            })
            .catch((error) => {
                toast.error('No such user found please try again')
                console.log("Error getting document:", error);
            })
    }

    return (
        <>
            <Header/>
            <Stack direction={'column'} alignItems={'center'}
                   sx={{
                       minHeight: '100vh',
                       backgroundImage: `url(${chargeBackground})`,
                       backgroundSize: 'cover'
                   }}>
                <IconButton onClick={() => navigate('/stand')} sx={{alignSelf: 'flex-start', color: 'white'}}> <IconChevronCompactLeft/> </IconButton>

                <Typography variant={'h1'} sx={{color: 'white', margin: 5}}><strong>Naplati</strong></Typography>

                <QrReaderC setQrCodeResult={setQrCodeResult}/>

                <Typography variant={'h1'}
                            sx={{color: 'white', margin: 5, fontSize: 50}}>
                    <strong>🪙{totalToCharge}</strong>
                </Typography>
            </Stack>
        </>
    )
};

export default AddCash;

